(() => {
  const header = document.getElementById("header-component");
  if (!header) return;

  let previousY = window.scrollY;
  let direction = "top";
  let ticking = false;
  const threshold = 6;
  const mobileHeaderQuery = window.matchMedia("(max-width: 993px)");
  const portraitTabletHeaderQuery = window.matchMedia("(orientation: portrait) and (max-width: 993px)");

  function applyState() {
    if ((mobileHeaderQuery.matches || portraitTabletHeaderQuery.matches)) {
      header.classList.remove("celinie-header--hidden", "celinie-header--compact");
      ticking = false;
      return;
    }

    const y = window.scrollY;

    if (y <= 32) {
      header.classList.remove("celinie-header--hidden", "celinie-header--compact");
    } else if (direction === "down") {
      header.classList.add("celinie-header--compact", "celinie-header--hidden");
    } else if (direction === "up") {
      header.classList.add("celinie-header--compact");
      header.classList.remove("celinie-header--hidden");
    }

    ticking = false;
  }

  mobileHeaderQuery.addEventListener?.("change", () => {
    if ((mobileHeaderQuery.matches || portraitTabletHeaderQuery.matches)) {
      header.classList.remove("celinie-header--hidden", "celinie-header--compact");
    }
  });

  window.addEventListener("scroll", () => {
    const y = window.scrollY;
    const delta = y - previousY;
    if (Math.abs(delta) >= threshold) {
      direction = delta > 0 ? "down" : "up";
      previousY = y;
    }
    if (!ticking) {
      window.requestAnimationFrame(applyState);
      ticking = true;
    }
  }, { passive: true });
})();

/* Each rendered header instance needs its own native popover target. */
(() => {
  const assignAccountPopoverTargets = () => {
    document.querySelectorAll("anchored-popover-component.account-popover").forEach((component, index) => {
      const trigger = component.querySelector(".account-button[popovertarget]");
      const panel = component.querySelector(".account-popover__panel[popover]");
      if (!trigger || !panel) return;

      const targetId = `celinie-account-popover-${index + 1}`;
      panel.id = targetId;
      trigger.setAttribute("popovertarget", targetId);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", assignAccountPopoverTargets, { once: true });
  } else {
    assignAccountPopoverTargets();
  }
})();

/* CelinieJourney mobile drawer menu-toggle close fallback v2 */
(() => {
  if (window.__celinieMobileDrawerMenuToggleCloseV2) return;
  window.__celinieMobileDrawerMenuToggleCloseV2 = true;

  const isMenuTrigger = (target) => {
    if (!(target instanceof Element)) return false;
    return Boolean(target.closest(".celinie-mobile-drawer .header__icon--menu, .celinie-header-drawer-mobile .header__icon--menu"));
  };

  const forceCloseDetails = (details) => {
    if (!details) return;
    const drawerElement = details.closest("header-drawer");
    const summary = details.querySelector("summary");
    summary?.setAttribute("aria-expanded", "false");
    details.classList.remove("menu-open");

    if (drawerElement && typeof drawerElement.close === "function") {
      drawerElement.close();
    }

    window.setTimeout(() => {
      details.classList.remove("menu-open");
      details.removeAttribute("open");
      details.open = false;
      summary?.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }, 0);
  };

  const closeOpenDrawerFromMenuButton = (event) => {
    if (!isMenuTrigger(event.target)) return;

    const openDetails = document.querySelector(".celinie-mobile-drawer details.menu-drawer-container[open], .celinie-header-drawer-mobile details.menu-drawer-container[open]");
    if (!openDetails) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    forceCloseDetails(openDetails);
  };

  window.addEventListener("click", closeOpenDrawerFromMenuButton, true);
})();

/* CelinieJourney mobile drawer manual summary toggle */
(() => {
  const closeDetails = (details) => {
    const summary = details?.querySelector("summary");
    const drawerElement = details?.closest("header-drawer");
    summary?.setAttribute("aria-expanded", "false");
    details?.classList.remove("menu-open");

    if (drawerElement && typeof drawerElement.close === "function") {
      drawerElement.close();
    }

    window.setTimeout(() => {
      if (!details) return;
      details.classList.remove("menu-open");
      details.removeAttribute("open");
      details.open = false;
      summary?.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }, 0);
  };

  const openDetails = (details, event) => {
    if (!details) return;
    const summary = details.querySelector("summary");
    const drawerElement = details.closest("header-drawer");
    details.setAttribute("open", "");
    details.open = true;
    summary?.setAttribute("aria-expanded", "true");

    if (drawerElement && typeof drawerElement.open === "function") {
      drawerElement.open(event);
    } else {
      details.classList.add("menu-open");
    }
  };

  window.celinieMobileDrawerManualToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();

    const trigger = event.currentTarget || event.target?.closest?.(".header__icon--menu");
    const details = trigger?.closest?.("details.menu-drawer-container");
    if (!details) return false;

    if (details.open || details.hasAttribute("open")) {
      closeDetails(details);
    } else {
      openDetails(details, event);
    }

    return false;
  };
})();
